import { render } from "./single-picture.vue?vue&type=template&id=51b36c5d&scoped=true"
import script from "./single-picture.vue?vue&type=script&lang=js"
export * from "./single-picture.vue?vue&type=script&lang=js"

import "./single-picture.vue?vue&type=style&index=0&id=51b36c5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b36c5d"]])

export default __exports__